import { render, staticRenderFns } from "./404.vue?vue&type=template&id=be39e99a"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
import style0 from "./404.vue?vue&type=style&index=0&id=be39e99a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports